module.exports = __webpack_public_path__ + "img/hero-dropdown-search-honda.bb5b107b.png";